import {
  ActionOverRecordTypes,
  AuditUserLookupService,
  FieldBuilder,
  FieldDefinition,
  IActionsSchema,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
  triggerAction,
  ZendraLocalizationServices,
} from '@zendra/shared';
import { DistributionService, FlowTypeService } from 'cbd-proxies/planning/proxy';

FieldBuilder.setNamespace('Geographic');

export const STANDTRANSFORMATIONHISTORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('id', 'Entity.StandTransformationHistory.FlowId')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .date('creationTime', 'Entity.StandTransformationHistory.FlowDate')
    .hideInChildForms()
    .hideByDefault()
    .build(),
  FieldBuilder
    .text('description', 'Entity.StandTransformationHistory.Description')
    .required()
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('inventoryDistributionDate', 'Entity.StandTransformationHistory.InventoryDistributionDate')
    .required()
    .maxLength(8)
    .build(),
  FieldBuilder
    .text('inventoryDistributionComment', 'Entity.StandTransformationHistory.InventoryDistributionComment')
    .maxLength(200)
    .build(),
  FieldBuilder
    .date('activityDistributionDate', 'Entity.StandTransformationHistory.ActivityDistributionDate')
    .required()
    .build(),
  FieldBuilder
    .text('activityDistributionComment', 'Entity.StandTransformationHistory.ActivityDistributionComment')
    .maxLength(200)
    .build(),
  FieldBuilder.foreignKey(
    'flowTypeId',
    'Entity.FlowType',
    FlowTypeService
  )
    .required()
    .display('name')
    .displayFromNested('flowTypeName')
    .sortBy('flowTypeName')
    .build(),
  FieldBuilder.foreignKey(
    'creatorId',
    'Entity.StandTransformationHistory.FlowUser',
    AuditUserLookupService
  )
    .display('displayName')
    .hideInChildForms()
    .hideByDefault()
    .build(),
  FieldBuilder.foreignKey(
    'inventoryDistributionStatusId',
    'Entity.StandTransformationHistory.InventoryDistributionStatus',
    DistributionService
  )
    .required()
    .display('name')
    .displayFromNested('inventoryDistributionStatusName')
    .sortBy('inventoryDistributionStatusName')
    .build(),
  FieldBuilder.foreignKey(
    'inventoryDistributionUserId',
    'Entity.StandTransformationHistory.InventoryDistributionUser',
    AuditUserLookupService
  )
    .display('displayName')
    .build(),
  FieldBuilder.foreignKey(
    'activityDistributionStatusId',
    'Entity.StandTransformationHistory.ActivityDistributionStatus',
    DistributionService
  )
    .required()
    .display('name')
    .displayFromNested('activityDistributionStatusName')
    .sortBy('activityDistributionStatusName')
    .build(),
  FieldBuilder.foreignKey(
    'activityDistributionUserId',
    'Entity.StandTransformationHistory.ActivityDistributionUser',
    AuditUserLookupService
  )
    .display('displayName')
    .build(),
];

const namespaceGeographic = ZendraLocalizationServices.Geographic;

export const STANDTRANSFORMATIONHISTORY_ACTION_IDS = {
  editInventoryDistribution: 0,
  editActivityDistribution: 1,
};

export const STANDTRANSFORMATIONHISTORY_ACTIONS_CONFIG: IActionsSchema = {
  singleRecord: [
    triggerAction(
      STANDTRANSFORMATIONHISTORY_ACTION_IDS.editInventoryDistribution,
      'Action.Trigger.EditInventoryDistribution',
      ActionOverRecordTypes.SingleRecord,
      namespaceGeographic,
    ),
    triggerAction(
      STANDTRANSFORMATIONHISTORY_ACTION_IDS.editActivityDistribution,
      'Action.Trigger.EditActivityDistribution',
      ActionOverRecordTypes.SingleRecord,
      namespaceGeographic,
    ),
  ],
};

export const STANDTRANSFORMATIONHISTORY_CONFIG = {
  entityName: 'StandTransformationHistory',
  localizationKey: 'Geographic::Entity.StandTransformationHistory',
  fields: STANDTRANSFORMATIONHISTORY_FIELDS,
  permission: 'PlanningGeography.StandTransformationHistories',
  actions: STANDTRANSFORMATIONHISTORY_ACTIONS_CONFIG,
  actionIds: STANDTRANSFORMATIONHISTORY_ACTION_IDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
